import Api from '@/services/Api'
import ApiDownloadReporte from '@/services/Api'

const HEADERURL = 'compras/orden_compra_e/';
const ACTION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_MODIFICAR_DETALLE = 'modificar_detalle';
const ACTION_MODIFICAR_TABLA = 'modificar_tabla';
const ACTION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACTION_GENERAR_ENTRADA_COMPRA = 'generar_entrada_compra';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_REPORTE_PDF = 'pdf';
const ACTION_MARCAR_URGENTE = 'marcar_como_urgente';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    pdf(id) {

        return Api().get(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`);

    },


    agregar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_DETALLE}/`, params);

    },

    modificar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_MODIFICAR_DETALLE}/`, params);

    },

    eliminar_detalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ELIMINAR_DETALLE}/`, params);

    },

    modificar_tabla(id, detalles) {
        return Api().post(`${HEADERURL}${id}/${ACTION_MODIFICAR_TABLA}/`, detalles);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },


    generar_entrada_compra(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_GENERAR_ENTRADA_COMPRA}/`);

    },

    marcar_como_urgente(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_MARCAR_URGENTE}/`);

    },



}